(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4647],{

/***/ 67655:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test-preparation",
      function () {
        return __webpack_require__(98995);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78182);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65615);
/* harmony import */ var _styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_5__);










const OurExpert = ({ data  })=>{
    const expertsettings = {
        dotsClass: (_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sliderDots),
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "expert-teams",
            className: (_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default().expertTeam),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        className: "text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                children: "Our Expert Team"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            id: "batches-slider",
                            className: (_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default().batchesSlider),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                ...expertsettings,
                                className: (_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default().slider),
                                children: data.map((team)=>{
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sliderCardDiv),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            className: (_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default().cardCust),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_5__.LazyLoadComponent, {
                                                    children: team?.personImagePath && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Img */ .Z.Img, {
                                                        height: 180,
                                                        width: 180,
                                                        variant: "top",
                                                        src: team.personImagePath,
                                                        alt: team?.personImageAltTag
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Body */ .Z.Body, {
                                                    className: (_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default().cardBody),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Title */ .Z.Title, {
                                                            className: (_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default().subTitle),
                                                            children: team?.name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Text */ .Z.Text, {
                                                            className: (_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default().textDate),
                                                            children: [
                                                                team?.title,
                                                                ", ",
                                                                team?.qualification
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Card__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Text */ .Z.Text, {
                                                            className: (_styles_ourexpertteam_module_scss__WEBPACK_IMPORTED_MODULE_6___default().textDate),
                                                            children: [
                                                                team?.yearsInIndustry,
                                                                " Years in the industry"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    });
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OurExpert);


/***/ }),

/***/ 98995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ test_preparation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./styles/TestPreparation.module.scss
var TestPreparation_module = __webpack_require__(38122);
var TestPreparation_module_default = /*#__PURE__*/__webpack_require__.n(TestPreparation_module);
// EXTERNAL MODULE: ./components/WebinarEvents.tsx
var WebinarEvents = __webpack_require__(72350);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js + 1 modules
var Breadcrumb = __webpack_require__(26699);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./components/FeaturedBlogs.tsx
var FeaturedBlogs = __webpack_require__(85684);
// EXTERNAL MODULE: ./components/StudentsAcheivement.tsx
var StudentsAcheivement = __webpack_require__(32892);
// EXTERNAL MODULE: ./components/Testimonial.tsx
var Testimonial = __webpack_require__(537);
// EXTERNAL MODULE: ./components/SeveneasySteps.tsx
var SeveneasySteps = __webpack_require__(36596);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./components/OurExpertteam.tsx
var OurExpertteam = __webpack_require__(30601);
// EXTERNAL MODULE: ./utils/fetchUtil.ts
var fetchUtil = __webpack_require__(40607);
// EXTERNAL MODULE: ./components/kcNewlatestupdates.tsx
var kcNewlatestupdates = __webpack_require__(79465);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-lazy-load-image-component/build/index.js
var build = __webpack_require__(72679);
// EXTERNAL MODULE: ./components/PST/FrequentlyAskedQuestions.tsx
var FrequentlyAskedQuestions = __webpack_require__(3011);
// EXTERNAL MODULE: ./components/PST/VideoTestimonials.tsx
var VideoTestimonials = __webpack_require__(55689);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
;// CONCATENATED MODULE: ./components/TestPreparation.tsx


























const Testpreps = (props)=>{
    const router = (0,next_router.useRouter)();
    const sliderRef = (0,react.useRef)(null);
    const { 0: expertTeam , 1: setExpertTeam  } = (0,react.useState)([]);
    const { 0: batchesData , 1: setBatchesData  } = (0,react.useState)([]);
    const settings = {
        dotsClass: (TestPreparation_module_default()).sliderDots,
        dots: true,
        infinite: true,
        speed: constants/* sliderSpeed.desktopSpeed */.Y$.desktopSpeed,
        slidesToShow: 3,
        slidesToScroll: 3,
        initialSlide: 0,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                    speed: constants/* sliderSpeed.mobileSpeed */.Y$.mobileSpeed
                }
            }
        ]
    };
    const expertsettings = {
        dotsClass: (TestPreparation_module_default()).sliderDots,
        dots: true,
        infinite: false,
        speed: constants/* sliderSpeed.desktopSpeed */.Y$.desktopSpeed,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    dots: true,
                    speed: constants/* sliderSpeed.mobileSpeed */.Y$.mobileSpeed
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                    speed: constants/* sliderSpeed.mobileSpeed */.Y$.mobileSpeed
                }
            }
        ]
    };
    const coursesettings = {
        dotsClass: (TestPreparation_module_default()).sliderDots,
        dots: true,
        infinite: false,
        speed: constants/* sliderSpeed.desktopSpeed */.Y$.desktopSpeed,
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 0,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                    infinite: false,
                    dots: true,
                    speed: constants/* sliderSpeed.mobileSpeed */.Y$.mobileSpeed
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    infinite: false,
                    dots: true,
                    speed: constants/* sliderSpeed.mobileSpeed */.Y$.mobileSpeed
                }
            }
        ]
    };
    (0,react.useEffect)(()=>{
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/our-expert-teams`, "GET", {}, "", false).then((res)=>setExpertTeam(res));
        (0,fetchUtil/* default */.Z)(`${"https://cms.studies-overseas.com"}/upcoming-batches?_sort=date:ASC`, "GET", {}, "", false).then((res)=>setBatchesData(res));
    }, []);
    const formInstance = (0,react.useRef)(null);
    const renderExamCards = (examData, sliderSettings, bgColor)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "batches-slider",
                className: (TestPreparation_module_default()).batchesSlider,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                    ...sliderSettings,
                    className: (TestPreparation_module_default()).slider,
                    children: examData?.length > 0 && examData.map((exam)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (TestPreparation_module_default()).sliderCardDiv,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                className: (TestPreparation_module_default()).cardCust,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Header */.Z.Header, {
                                        style: {
                                            backgroundColor: bgColor
                                        },
                                        className: (TestPreparation_module_default()).cardheader,
                                        children: exam.testName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                        className: (TestPreparation_module_default()).cardBody,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: exam.offerings.length > 0 && exam.offerings.map((offer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: offer
                                                    }, index))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (TestPreparation_module_default()).footerBtn,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: exam.viewMoreLink,
                                                        className: (TestPreparation_module_default()).viewMore,
                                                        onClick: ()=>router.push(exam.viewMoreLink),
                                                        children: "View More"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        variant: "primary",
                                                        size: "lg",
                                                        className: `btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`,
                                                        onClick: ()=>{
                                                            !props?.pageData?.meta?.jotforms[0]?.jotformid && router.push(props?.pageData?.externalLink);
                                                        },
                                                        children: "Enroll Now"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, exam.id);
                    })
                })
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestPreparation_module_default()).dynamicBg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (TestPreparation_module_default()).mainSectionBg,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "d-block d-sm-none text-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-flex justify-content-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                        className: (TestPreparation_module_default()).mobileBreadCrum,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "/",
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                children: "Home"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "",
                                                                children: "Test Preparation"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: props?.pageData?.mainImagePath,
                                                    alt: props?.pageData?.mainImageAltTag,
                                                    width: 640,
                                                    height: 507
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (TestPreparation_module_default()).mainContent,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "d-none d-sm-block text-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumb/* default */.Z, {
                                                        className: (TestPreparation_module_default()).mobileBreadCrum,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "/",
                                                                style: {
                                                                    opacity: 0.5
                                                                },
                                                                children: "Home"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumb/* default.Item */.Z.Item, {
                                                                href: "",
                                                                children: "Test Preparation"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    children: props?.pageData?.title
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: props?.pageData?.description
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    variant: "primary",
                                                    size: "lg",
                                                    className: `btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`,
                                                    onClick: ()=>{
                                                        !props?.pageData?.meta?.jotforms[0]?.jotformid && router.push(props?.pageData?.externalLink);
                                                    },
                                                    children: props?.pageData?.bannerBtn?.label || " Enquire Now"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (TestPreparation_module_default()).mainContent,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-none d-sm-block",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TestPreparation_module_default()).contentImgGirl,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: props?.pageData?.mainImagePath,
                                                    alt: props?.pageData?.mainImageAltTag,
                                                    width: 640,
                                                    height: 507
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            batchesData.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestPreparation_module_default()).upcomingBatches,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: props?.pageData?.batchesTitle
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (TestPreparation_module_default()).batchesSlider,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                            ...settings,
                                            ref: sliderRef,
                                            className: (TestPreparation_module_default()).slider,
                                            children: batchesData.map((batch)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (TestPreparation_module_default()).sliderCardDiv,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                                                        className: (TestPreparation_module_default()).cardCust,
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(build.LazyLoadComponent, {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Img */.Z.Img, {
                                                                    variant: "top",
                                                                    src: batch?.testImagePath,
                                                                    alt: batch?.testImageAltTag
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Body */.Z.Body, {
                                                                className: (TestPreparation_module_default()).cardBody,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Text */.Z.Text, {
                                                                        className: (TestPreparation_module_default()).textDate,
                                                                        children: batch?.testDesc
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                                                        className: (TestPreparation_module_default()).subTitle,
                                                                        children: [
                                                                            "Date: ",
                                                                            (0,format["default"])(new Date(batch.date), "dd MMM yyyy")
                                                                        ]
                                                                    }),
                                                                    batch.time && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Title */.Z.Title, {
                                                                        className: (TestPreparation_module_default()).subTitle,
                                                                        children: [
                                                                            "Time: ",
                                                                            batch.time,
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Text */.Z.Text, {
                                                                        className: (TestPreparation_module_default()).subTitle,
                                                                        children: [
                                                                            "Duration : ",
                                                                            batch?.duration
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Text */.Z.Text, {
                                                                        className: (TestPreparation_module_default()).subTitle,
                                                                        children: [
                                                                            "Batch : ",
                                                                            batch?.batch
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: (TestPreparation_module_default()).footerBtn,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                href: `/coaching/${batch.examType.replaceAll("_", "-")}`,
                                                                                onClick: ()=>router.push(`/coaching/${batch.examType.replaceAll("_", "-")}`),
                                                                                className: (TestPreparation_module_default()).viewMore,
                                                                                children: "View More"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                                variant: "primary",
                                                                                size: "lg",
                                                                                className: `btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`,
                                                                                children: batch?.button?.label || "Enroll Now"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, batch.id);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (TestPreparation_module_default()).arrowsClass,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (TestPreparation_module_default()).btcircle,
                                                    onClick: ()=>sliderRef?.current?.slickPrev(),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/new-images/left-arrow.svg",
                                                        height: 17,
                                                        width: 10,
                                                        alt: "left-arrow"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (TestPreparation_module_default()).btcircle,
                                                    onClick: ()=>sliderRef?.current?.slickNext(),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: "/new-images/right-arrow.svg",
                                                        height: 17,
                                                        width: 10,
                                                        alt: "right-arrow"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestPreparation_module_default()).multiCountry,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            className: "text-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: props?.pageData?.kcAcademy?.title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                        src: props?.pageData?.kcAcademy?.newImagePath?.imageUrl,
                                        alt: props?.pageData?.kcAcademy?.newImagePath?.alt,
                                        width: 490,
                                        height: 444
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    xs: 12,
                                    lg: 6,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (TestPreparation_module_default()).multi_country_content,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: props?.pageData?.kcAcademy?.description
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                children: props?.pageData?.kcAcademy?.offerings?.length > 0 && props.pageData.kcAcademy.offerings.map((offer, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                        children: offer
                                                    }, index))
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TestPreparation_module_default()).buttonAlign,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    variant: "primary",
                                                    size: "lg",
                                                    className: `btn ${(0,helpers/* isFrappeOrJotFormClass */.gd)(props?.pageData?.meta?.jotforms[0]?.jotformid)}`,
                                                    onClick: ()=>{
                                                        !props?.pageData?.meta?.jotforms[0]?.jotformid && router.push(props?.pageData?.externalLink);
                                                    },
                                                    children: props?.pageData?.kcAcademy?.bannerBtn?.label || "Enroll Now"
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestPreparation_module_default()).courseslist,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                xs: 12,
                                lg: 6,
                                className: (TestPreparation_module_default()).cardTop,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "For Bachelors"
                                            })
                                        })
                                    }),
                                    props?.pageData?.bachelors?.length > 0 && renderExamCards(props?.pageData?.bachelors, coursesettings, "#FDC98D")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                xs: 12,
                                lg: 6,
                                className: (TestPreparation_module_default()).cardTop,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "For Masters"
                                            })
                                        })
                                    }),
                                    props?.pageData?.masters?.length > 0 && renderExamCards(props?.pageData?.masters, coursesettings, "#FBBFB6")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                xs: 12,
                                lg: 12,
                                className: (TestPreparation_module_default()).cardTop,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: "English Proficiency"
                                            })
                                        })
                                    }),
                                    props?.pageData?.englishProficiency?.length > 0 && renderExamCards(props?.pageData?.englishProficiency, expertsettings, "#B8AAEE")
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                xs: 12,
                                lg: 12,
                                className: (TestPreparation_module_default()).cardTop,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                        className: "text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: props.pageData.languagePrep.title
                                            })
                                        })
                                    }),
                                    props?.pageData?.languagePrep?.languages?.length > 0 && renderExamCards(props.pageData.languagePrep.languages, expertsettings, "#B8AAEE")
                                ]
                            })
                        ]
                    })
                })
            }),
            expertTeam.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(OurExpertteam/* default */.Z, {
                data: expertTeam
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StudentsAcheivement/* default */.Z, {
                customClass: true,
                slug: "our-students-achievements?type=coaching"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Testimonial/* default */.Z, {
                title: "Our students love us",
                bgColor: "#FFFFFF",
                slug: `student-testimonials?type=coaching&_limit=15&_sort=id:DESC`
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestPreparation_module_default()).achievements,
                children: props.pageData?.videoTestimonial && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoTestimonials/* default */.Z, {
                    ...props.pageData.videoTestimonial
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestPreparation_module_default()).multiCountry,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 6,
                                className: (TestPreparation_module_default()).tiups,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (TestPreparation_module_default()).multi_country_content,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: (TestPreparation_module_default()).h2title,
                                            children: "1200+ Global University Tie Ups"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            children: "Study in the global university of your choice!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "We value your career aspirations, which is why we map your preferences with the best that our global universities have to offer. Thousands of our students are pursuing their programs and aspirations in eminent universities globally and we welcome you to pursue yours!"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                xs: 12,
                                lg: 6,
                                className: (TestPreparation_module_default()).tiupImg,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                    src: props?.pageData?.multiCountry?.multiCountryImage?.imageUrl,
                                    alt: props?.pageData?.multiCountry?.multiCountryImage?.alt,
                                    width: 430,
                                    height: 565
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WebinarEvents["default"], {
                    headingLevel: 2
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestPreparation_module_default()).sevenStepbg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SeveneasySteps/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestPreparation_module_default()).testPrepLatestKcUpdates,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(kcNewlatestupdates["default"], {
                    ...props
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestPreparation_module_default()).homePageBlogs,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedBlogs["default"], {})
            }),
            props.pageData?.faq && /*#__PURE__*/ (0,jsx_runtime.jsx)(FrequentlyAskedQuestions/* default */.Z, {
                ...props.pageData.faq
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TestPreparation_module_default()).studentFooter,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (TestPreparation_module_default()).session,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            lg: 9,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        children: "Start your Study Abroad Journey with KC "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Book a free in person or virtual counselling session with our experts now!"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xs: 12,
                                            lg: 3,
                                            className: (TestPreparation_module_default()).btCenter,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/contact-us",
                                                className: "btn btn-primary",
                                                children: "Contact Us"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var TestPreparation = (Testpreps);

;// CONCATENATED MODULE: ./pages/test-preparation.tsx




const Testprep = (props)=>{
    const { meta  } = props.pageData;
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--navbar-color", "#6C48F0");
        customStyle.setProperty("--navbar-menu-color", "#ffffff");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            meta && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...meta
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestPreparation, {
                ...props
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var test_preparation = (Testprep);


/***/ }),

/***/ 38122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dynamicBg":"TestPreparation_dynamicBg__IYhEw","mainSectionBg":"TestPreparation_mainSectionBg__8TQZK","mainContent":"TestPreparation_mainContent__Q5hi1","contentImgGirl":"TestPreparation_contentImgGirl__uNoOv","multiCountry":"TestPreparation_multiCountry__tj_ax","tiups":"TestPreparation_tiups__gIJJ_","multi_country_content":"TestPreparation_multi_country_content__VGUav","h2title":"TestPreparation_h2title__fiPEU","viewMore":"TestPreparation_viewMore__mdqSb","buttonAlign":"TestPreparation_buttonAlign___zXq5","tiupImg":"TestPreparation_tiupImg__wpdTz","WebinarHomeLineImg":"TestPreparation_WebinarHomeLineImg__33X8H","home_page_service_div":"TestPreparation_home_page_service_div__h4tVn","serviceHead":"TestPreparation_serviceHead__oj0e2","service_content":"TestPreparation_service_content__ASFVO","serviceAnchor":"TestPreparation_serviceAnchor__yFvwb","service_img_slider":"TestPreparation_service_img_slider__Zq5LR","webinarEventsMianSection":"TestPreparation_webinarEventsMianSection__coEw6","testPrepLatestKcUpdates":"TestPreparation_testPrepLatestKcUpdates__orzja","homePageBlogs":"TestPreparation_homePageBlogs__54KUR","uniTieUp":"TestPreparation_uniTieUp__Ht3nc","Strengths":"TestPreparation_Strengths__rwPd9","sliderDots":"TestPreparation_sliderDots__6Z6XJ","slick-slide":"TestPreparation_slick-slide__ZnVxN","bgstudentslove":"TestPreparation_bgstudentslove__Y0_WV","bgsevensteps":"TestPreparation_bgsevensteps__9FmXN","upcomingBatches":"TestPreparation_upcomingBatches__Jo34g","batchesSlider":"TestPreparation_batchesSlider__LEP2T","textDate":"TestPreparation_textDate__VSrxm","subTitle":"TestPreparation_subTitle__fOo4x","footerBtn":"TestPreparation_footerBtn__72bfc","smallText":"TestPreparation_smallText__TDRWK","cardCust":"TestPreparation_cardCust__jUuIA","btEduExpo":"TestPreparation_btEduExpo__xHGXS","cardBody":"TestPreparation_cardBody__sQEeh","expertTeam":"TestPreparation_expertTeam__ATPWi","courseslist":"TestPreparation_courseslist__M3qeE","cardheader":"TestPreparation_cardheader__GJGC_","cardTop":"TestPreparation_cardTop__I0oc8","sevenStepbg":"TestPreparation_sevenStepbg__Wy5lD","studentFooter":"TestPreparation_studentFooter__GDlSG","session":"TestPreparation_session__roQTA","btCenter":"TestPreparation_btCenter__O304i","arrowsClass":"TestPreparation_arrowsClass__UUcgy","btcircle":"TestPreparation_btcircle__l_juE"};

/***/ }),

/***/ 65615:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"expertTeam":"ourexpertteam_expertTeam__n5Hzv","batchesSlider":"ourexpertteam_batchesSlider__r72zi","sliderDots":"ourexpertteam_sliderDots__KyjoL","textDate":"ourexpertteam_textDate__nMC8_","subTitle":"ourexpertteam_subTitle__QW_Nt","smallText":"ourexpertteam_smallText__nu4m2","cardCust":"ourexpertteam_cardCust__Ki5R_","cardBody":"ourexpertteam_cardBody__I1BzX"};

/***/ }),

/***/ 98745:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 98322:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 26699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_Breadcrumb; }
});

// EXTERNAL MODULE: ./node_modules/react-bootstrap/node_modules/classnames/index.js
var classnames = __webpack_require__(44036);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/ThemeProvider.js
var ThemeProvider = __webpack_require__(76792);
// EXTERNAL MODULE: ./node_modules/@restart/ui/esm/Anchor.js + 10 modules
var Anchor = __webpack_require__(23646);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/BreadcrumbItem.js





const defaultProps = {
  active: false,
  linkProps: {}
};
const BreadcrumbItem = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  active,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = Anchor/* default */.Z,
  linkProps,
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames_default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkComponent, { ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ var esm_BreadcrumbItem = (BreadcrumbItem);
;// CONCATENATED MODULE: ./node_modules/react-bootstrap/esm/Breadcrumb.js





const Breadcrumb_defaultProps = {
  label: 'breadcrumb',
  listProps: {}
};
const Breadcrumb = /*#__PURE__*/react.forwardRef(({
  bsPrefix,
  className,
  listProps,
  children,
  label,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,ThemeProvider/* useBootstrapPrefix */.vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("ol", { ...listProps,
      className: classnames_default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.defaultProps = Breadcrumb_defaultProps;
/* harmony default export */ var esm_Breadcrumb = (Object.assign(Breadcrumb, {
  Item: esm_BreadcrumbItem
}));

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,9882,3656,474,5684,9465,2350,3593,1437,3213,7657,9774,2888,179], function() { return __webpack_exec__(67655); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);